// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__kgKds","hoverable":"card_hoverable__rOax0"};